import { Outlet } from "react-router-dom";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ChatWidget } from "@/components/ChatWidget";
import { NoiseOverlay } from "@/components/NoiseOverlay";

export const MarketingLayout = () => (
  <SmoothScroll>
    <div className="relative min-h-screen mesh-bg">
      <NoiseOverlay />
      <Navbar />
      <main className="relative z-10">
        <Outlet />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  </SmoothScroll>
);
